<template>
  <Listbox v-model="locale" as="div">
    <div class="relative mt-1">
      <ListboxButton
        class="relative w-full cursor-default rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-left hover:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 sm:text-sm"
      >
        <span class="flex items-center">
          <span class="ml-3 flex flex-row gap-3 truncate">
            <img
              class="h-3 w-4 mt-1"
              :src="`${selectedLanguage?.flag}`"
              role="presentation"
              :alt="selectedLanguage?.label"
            />

            <span> {{ selectedLanguage?.label }}</span>
          </span>
        </span>
        <span class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
          <SelectorIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
        </span>
      </ListboxButton>
      <ListboxOptions
        class="absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
      >
        <ListboxOption
          v-for="language in languages"
          :key="language.id"
          v-slot="{ active, selected }"
          as="template"
          :value="language.value"
          @click="setLocalSelector()"
        >
          <li
            :class="[
              active ? 'bg-primary-500 text-white' : 'text-gray-900',
              'relative cursor-default select-none py-2 pl-3 pr-9'
            ]"
          >
            <span :class="[selected ? 'font-semibold' : 'font-normal', 'ml-3 flex flex-row gap-3 truncate']">
              <img class="h-3 w-4 mt-1" :src="`${language.flag}`" role="presentation" :alt="selected.label" />

              <span> {{ language.label }}</span>
            </span>
            <span
              v-if="selected"
              :class="[active ? 'text-white' : 'text-primary-500', 'absolute inset-y-0 right-0 flex items-center pr-4']"
            >
              <CheckIcon class="h-5 w-5" aria-hidden="true" />
            </span>
          </li>
        </ListboxOption>
      </ListboxOptions>
    </div>
  </Listbox>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/vue';
import { CheckIcon, SelectorIcon } from '@heroicons/vue/solid';
import { languages as globalLanguages } from '@infuse/ui/utils';

export default defineComponent({
  name: 'LocaleSwitcher',
  components: {
    Listbox,
    ListboxButton,
    ListboxOption,
    ListboxOptions,
    SelectorIcon,
    CheckIcon
  },

  setup() {
    const { locale } = useI18n({ useScope: 'global' });

    const supportedLanguages = ['nl', 'en'];
    const languages = globalLanguages.filter((lang) => supportedLanguages.includes(lang.value));
    const selectedLanguage = languages.find((lang) => lang.value === locale.value);

    return {
      locale,
      languages: languages,
      selectedLanguage
    };
  },
  methods: {
    setLocalSelector() {
      localStorage.setItem('locale', this.locale);
      this.selectedLanguage = this.languages.find((lang) => lang.value === this.locale);
    }
  }
});
</script>

<style scoped>
.locale-select {
  width: 150px;
}
</style>
